"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TrashOffOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_TrashOffOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.713 2.166 10.815.818A1.632 1.632 0 0 0 9.41 0H6.59C6.007 0 5.48.318 5.185.818L3.732 3H.5a.5.5 0 0 0 0 1h1.077l.593 7.709.931-.931L2.58 4h7.299l1-1H4.934l1.102-1.654.008-.015A.633.633 0 0 1 6.59 1h2.82c.214 0 .424.118.546.33l.009.016 1.026 1.541.722-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.379V6.5a.5.5 0 0 0-1 0v1.879l1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.14 15.154 14.3-14.3a.368.368 0 0 0 .007-.008l.7-.7a.5.5 0 0 1 .707.708L13.707 3H15.5a.5.5 0 0 1 0 1h-1.077l-.816 10.615A1.5 1.5 0 0 1 12.11 16H3.889a1.5 1.5 0 0 1-1.496-1.385l-.021-.28-1.518 1.519a.5.5 0 0 1-.715-.7ZM5.5 12.5v-1.293l-2.197 2.197.088 1.134a.5.5 0 0 0 .498.462h8.222a.5.5 0 0 0 .498-.462L13.42 4h-.713l-2.265 2.265c.037.07.058.15.058.235v6a.5.5 0 0 1-1 0V7.207l-3 3V12.5a.5.5 0 0 1-1 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_TrashOffOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = TrashOffOutline;
exports["default"] = _default;